<template>
	<div>
		<page-header>
			<template #title>
				<!-- <span>{{ ClientName ?? "Dashboard" }}</span> -->
				<!-- <span>{{ accName ?? "Dashboard" }}</span> -->
				<!-- <b-button
					variant="light"
					:to="{ name: 'organization' }"
					title="Organization Settings"
					class="ml-2 text-center"
				>
					<font-awesome-icon icon="cog" class="text-muted px-0 mx-0" />
				</b-button> -->
				<router-link :to="{ name: 'organization' }" class="text-muted px-1 mx-1 ">
					<span>{{ accName ?? "Dashboard" }}</span>
					<!-- <font-awesome-icon icon="bell" class="text-muted px-1 mx-1" />
					<span class="notification-badge">4</span> -->
				</router-link>
				
					<!-- <font-awesome-icon icon="bell" class="text-muted px-1 mx-1" />
					<span class="notification-badge">3</span> -->
				<div class="d-inline-block" v-if="$filters.formatNumber(unassignedAppeals)">
					<!-- <font-awesome-icon icon="bell" class="text-muted px-1 mx-1 ringing" title="Unassigned Appeals"/>
					<span class="notification-badge">{{ $filters.formatNumber(unassignedAppeals) }}</span> -->
					<!-- <a href="#" @click="toggleNotification">
						<font-awesome-icon icon="bell" class="text-muted px-1 mx-1 ringing" title="Unassigned Appeals"/>
						<span class="notification-badge">{{ $filters.formatNumber(unassignedAppeals) }}a</span>
					</a> -->
				</div>
				<!-- <div v-if="showNotification" class="notification-bar">
						<div v-for="(notification, index) in notifications" :key="index" class="notification">
							{{ notification }}
						</div>
				</div> -->
				<router-link to="/appeals/unassigned" style="text-decoration: none;" class="d-inline-block mr-4">
					<b-badge style="background-color: #F8D3D3; color: black; padding: 7%;" v-if="totalUnassignedAppeals">{{ totalUnassignedAppeals }}&nbsp;&nbsp;{{ totalUnassignedAppeals === 1 ? 'Unassigned Appeal' : 'Unassigned Appeals' }}</b-badge>
				</router-link>
				<router-link to="/cases/" style="text-decoration: none;" class="d-inline-block mr-4" v-if="totalUnassignedCases">
					<b-badge style="background-color: #FAE0E0; color: black; padding: 7%;">{{ totalUnassignedCases }}&nbsp;&nbsp;{{ totalUnassignedCases === 1 ? 'Unassigned Case' : 'Unassigned Cases' }}</b-badge>
				</router-link>
			</template>
			<template #buttons>
				<b-button :to="{ name: 'cases.add' }" variant="light" title="New Case" class="btn btn-outline-success">
					<font-awesome-icon icon="plus" fixed-width />
					<span>New Case</span>
				</b-button>
			</template>
		</page-header>

		<b-container fluid class="my-4">
			 <!-- <div class="container-fluid"> 
				<b-row> 
					<div class="section-box">
						<h6 class="text-muted">{{currentMonth}}</h6>
					</div>
					<b-card-group class="shadow-sm mb-4">
						<b-card class="text-center p-1">
							<p class="h4 font-weight-bold mb-1">
								<span v-if="!openClaimsTotal" class="text-muted">&mdash;</span>
								<span v-else class="mx-0 px-0">
									 {{ $filters.abbreviatedCurrency(openClaimsTotal) }} 
									{{newCaseNum}}
								</span>
							</p>
							<p class="small text-muted mb-0">New Cases</p>
							<p class="smaller-text-muted text-muted">(total no.)</p>
						</b-card>
						<b-card class="text-center p-1">
							<p class="h4 font-weight-bold mb-1">
								<span v-if="!openClaimsTotal" class="text-muted">&mdash;</span>
								<span v-else class="mx-0 px-0">
									 {{ $filters.abbreviatedCurrency(openClaimsTotal) }} 
									{{totalOpenAppeal}}
								</span>
							</p>
							<p class="small text-muted mb-0">New Appeals</p>
							<p class="smaller-text-muted text-muted">(total no.)</p>
						</b-card>
						<b-card class="text-center p-1">
							<p class="h4 font-weight-bold mb-1">
								<span v-if="!openClaimsTotal" class="text-muted">&mdash;</span>
								<span v-else>
									 {{ favorableCasesPercent }}% 
									{{ $filters.formatNumber(unassignedAppeals) }}
								</span>
							</p>
							<p class="small text-muted mb-0">Unassigned Appeals</p>
						</b-card>
					 <b-card class="text-center">
							<p class="h4 font-weight-bold mb-1">
								<span v-if="!openClaimsTotal" class="text-muted">&mdash;</span>
								<span v-else class="mx-0 px-0">
									
									{{toalCaseClaims}}
								</span>
							</p>
							<p class="small text-muted mb-0">Open Cases</p>
						</b-card> 
						<b-card class="text-center p-1">
							<p class="h4 font-weight-bold mb-1">
								<span v-if="!openClaimsTotal" class="text-muted">&mdash;</span>
								<span v-else class="mx-0 px-0">
									 {{ $filters.abbreviatedCurrency(reimbursedTotal) }}
									{{ $filters.formatNumber(openCaseRequestCount) }}
								</span>
							</p>
							<p class="small text-muted mb-0">Open Requests</p>
						</b-card> 
						<b-card class="text-center bg-purple" >
							<p class="h4 font-weight-bold mb-1 text-white">
								
								<span >{{ totalCases }}</span>
							</p>
							<p class="small mb-0 text-white">Total Cases</p>
						</b-card>
						<b-card class="text-center "style="background-color: #808080">
							<p class="h4 font-weight-bold mb-1 text-white">
								<span >{{ openCases }}</span>
							</p>
							<p class="small mb-0 text-white">Open Cases</p>
						</b-card>
						<b-card class="text-center" style="background-color: #00563f">
							<p class="h4 font-weight-bold mb-1 text-white">
								<span>{{ closedCases }}</span>
							</p>
							<p class="small mb-0 text-white">Closed Cases</p>
						</b-card> 
					</b-card-group>
					<b-card-group class="shadow-sm mb-4">
						<b-card class="text-center p-1">
							<p class="h4 font-weight-bold mb-1">
								<span v-if="!openClaimsTotal" class="text-muted">&mdash;</span>
								<span v-else class="mx-0 px-0">
									 {{ $filters.abbreviatedCurrency(openClaimsTotal) }} 
									${{toalCaseClaims}}K
								</span>
							</p>
							<p class="small text-muted mb-0">New Cases</p>
							<p class="smaller-text-muted text-muted">(Amount)</p>
						</b-card>
						<b-card class="text-center p-1">
							<p class="h4 font-weight-bold mb-1">
								<span v-if="!openClaimsTotal" class="text-muted">&mdash;</span>
								<span v-else class="mx-0 px-0">
									 {{ $filters.abbreviatedCurrency(openClaimsTotal) }} 
									${{recentReiumbersedAmt}}K
								</span>
							</p>
							<p class="small text-muted mb-0">Paid/Partial</p>
							<p class="smaller-text-muted text-muted">(Amount)</p>
						</b-card>
						<b-card class="text-center p-1">
							<p class="h4 font-weight-bold mb-1">
								<span v-if="!openClaimsTotal" class="text-muted">&mdash;</span>
								<span v-else>
									 {{ favorableCasesPercent }}% 
									${{ recentPaid }}K
								</span>
							</p>
							<p class="small text-muted mb-0">Write Off</p>
						</b-card>
						 <b-card class="text-center">
							<p class="h4 font-weight-bold mb-1">
								<span v-if="!openClaimsTotal" class="text-muted">&mdash;</span>
								<span v-else class="mx-0 px-0">
									
									{{toalCaseClaims}}
								</span>
							</p>
							<p class="small text-muted mb-0">Open Cases</p>
						</b-card> -->
						<!-- <b-card class="text-center p-2">
							<p class="h4 font-weight-bold mb-1">
								<span v-if="!openClaimsTotal" class="text-muted">&mdash;</span>
								<span v-else class="mx-0 px-0">
									 {{ $filters.abbreviatedCurrency(reimbursedTotal) }} 
									{{ $filters.formatNumber(openCaseRequestCount) }}
								</span>
							</p>
							<p class="small text-muted mb-0">Open Requests</p>
						</b-card>  -->
						<!-- <b-card class="text-center bg-purple" >
							<p class="h4 font-weight-bold mb-1 text-white">
								
								<span >{{ totalCases }}</span>
							</p>
							<p class="small mb-0 text-white">Total Cases</p>
						</b-card>
						<b-card class="text-center "style="background-color: #808080">
							<p class="h4 font-weight-bold mb-1 text-white">
								<span >{{ openCases }}</span>
							</p>
							<p class="small mb-0 text-white">Open Cases</p>
						</b-card>
						<b-card class="text-center" style="background-color: #00563f">
							<p class="h4 font-weight-bold mb-1 text-white">
								<span>{{ closedCases }}</span>
							</p>
							<p class="small mb-0 text-white">Closed Cases</p>
						</b-card> 
					</b-card-group>
					 <b-card-group class="shadow-sm mb-4 col-12" style="width: 50%; overflow-x: auto;">
							 <b-card class="text-center">
								<p class="h4 font-weight-bold mb-1">
									<span v-if="!favorableCasesPercent" class="text-muted">&mdash;</span>
									<span v-else>{{ favorableCasesPercent }}%</span>
								</p>
								<p class="small text-muted mb-0">Favorable Cases</p>
							</b-card>
							<b-card class="text-center">
								<p class="h4 font-weight-bold mb-1">
									<span v-if="!openClaimsTotal" class="text-muted">&mdash;</span>
									<span v-else class="mx-0 px-0">
										{{ $filters.abbreviatedCurrency(openClaimsTotal) }}
									</span>
								</p>
								<p class="small text-muted mb-0">Open Claims</p>
							</b-card>
							<b-card class="text-center">
								<p class="h4 font-weight-bold mb-1">
									<span v-if="!reimbursedTotal" class="text-muted">&mdash;</span>
									<span v-else class="mx-0 px-0">
										{{ $filters.abbreviatedCurrency(reimbursedTotal) }}
									</span>
								</p>
								<p class="small text-muted mb-0">Reimbursed</p>
							</b-card> 
							<b-card class="text-center mr-3 rounded-lg" style="background-color:#d8e4bc" >
								<p class="h4 font-weight-bold mb-1 text-sm ">
									<span>{{ totalAppeal }}</span>
								</p>
								<p class="small mb-0 ">Total Appeals</p>
							</b-card>
							<b-card class="text-center mr-3 rounded-lg" style="background-color:#d8e4bc" >
								<p class="h4 font-weight-bold mb-1 text-sm ">
									<span>{{ totalOpenAppeal }}</span>
								</p>
								<p class="small mb-0">Open Appeals</p>
							</b-card>
							<b-card class="text-center mr-3 rounded-lg" style="background-color:#d8e4bc" >
								<p class="h4 font-weight-bold mb-1 text-sm ">
									<span>{{ totalClosedAppeal }}</span>
								</p>
								<p class="small mb-0 ">Closed Appeals</p>
							</b-card>
							<b-card class="text-center mr-3 rounded-lg" style="background-color:#fdfd96" >
								<p class="h4 font-weight-bold mb-1 text-sm ">
									<span>{{ totalunFavAppeal }}</span>
								</p>
								<p class="small mb-0 ">Partially Favorable Appeals</p>
							</b-card>
							<b-card class="text-center mr-3 rounded-lg" style="background-color:#fe5757" >
								<p class="h4 font-weight-bold mb-1 text-sm ">
									<span>{{ totalPartFavAppeal }}</span>
								</p>
								<p class="small mb-0 ">Unfavorable Appeals</p>
							</b-card>
							<b-card class="text-center mr-3 rounded-lg" style="background-color:#c5e384" >
								<p class="h4 font-weight-bold mb-1 text-lg ">
									<span>{{ totalfavAppeal }}</span>
								</p>
								<p class="small mb-0 ">Favorable Appeals</p>
							</b-card>
							 <b-card class="text-center mr-3 rounded">
								
								<p class="h4 font-weight-bold mb-1 ">
									<span >{{ totalCases }}</span>
								</p>
								<p class="small mb-0 "><span>Total Cases</span></p>
							</b-card>
							<b-card class="text-center mr-3 rounded" >
								<p class="h4 font-weight-bold mb-1 ">
									<span >{{ openCases }}</span>
								</p>
								<p class="small mb-0 ">Open Cases</p>
							</b-card>
							<b-card class="text-center mr-3 rounded" >
								<p class="h4 font-weight-bold mb-1 ">
									<span>{{ closedCases }}</span>
								</p>
								<p class="small mb-0 ">Closed Cases</p>
							</b-card>
							
					</b-card-group> 
				</b-row> 
			</div>  -->
			<b-row>
				<b-col cols="12" md="6" lg="7" xl="7" class="mb-4">
					<!-- <b-alert fade variant="warning" :show="incomingDocumentCount > 0" class="mb-4">
						<b-row class="d-flex align-items-center">
							<b-col cols="12" lg="9" class="text-lg-left">
								<p class="mb-lg-0">
									<font-awesome-icon icon="exclamation-triangle" fixed-width />
									<span v-if="incomingDocumentCount == 1">
										There is {{ incomingDocumentCount }} incoming document awaiting processing.
									</span>
									<span v-else>
										There are {{ incomingDocumentCount }} incoming documents awaiting processing.
									</span>
								</p>
							</b-col>
							<b-col cols="12" lg="3" class="text-lg-right">
								<b-button
									variant="light"
									:to="{ name: 'incomingDocuments' }"
									class="d-block d-lg-inline-block"
									title="View Incoming Documents"
								>
									<span>View</span>
									<font-awesome-icon icon="chevron-right" />
								</b-button>
							</b-col>
						</b-row>
					</b-alert> -->

					<b-card no-body class="mb-4 shadow-sm">
						<b-card-header header-tag="header" role="tab" class="p-0 border-b-0">
							<!-- <b-button
								block
								@click="collapseCalendar = !collapseCalendar"
								variant="light"
								role="tab"
								class="text-left px-4 py-3 m-0 rounded-b-0"
							>
								<font-awesome-icon
									class="ml-0"
									:icon="collapseCalendar ? 'chevron-down' : 'chevron-right'"
									fixed-width
								/>
								Calendar
							</b-button> -->
						</b-card-header>
						<!-- Full Calendar code  -->
						<div>
							<b-row>
								<b-col cols="12" md="12" lg="12" xl="12" class="mb-3">
									<!-- card to display appeals -->
									<b-row>
										<b-col>
											<h6 style="margin-left:8px;margin-top:8px;">Appeals Overview</h6>
										</b-col>
									</b-row>
									<b-row>
										<!-- <b-col cols="2" lg="2" class="py-0" style="background-color: whitesmoke; border: 1px white; padding-left: 0px; padding-right: 0px; margin-left: 16px; height: 70px; width: 125px;">
												<b-card 
													class="text-center" 
													text-variant="black" 
													style="height: 85px; box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1); border-bottom-color: green; border-bottom-width: medium; height: 70px; width: 125px;border-radius: unset;"
													:class="{ 'gradient-background': showTotalAppealsCount }"
													@click="showTotalAppealsInfo"
													>
													<h6 style="margin-bottom: 3px !important;">({{ AllAppealsCount }})</h6>
													<small class="text-muted" style="font-size: 10px;">All Appeals</small>
												</b-card>
										</b-col> -->
										<b-col cols="2" lg="2" class="py-0" style="background-color: whitesmoke;border: 1px white;padding-left:0px;padding-right:0px;height:85px;margin-left:23px !important;height:70px;width:125px;">
											<template>
												<b-card 
													class="text-center" 
													text-variant="black" 
													style="height:85px;box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);border-bottom-color: #008FFF;border-bottom-width: medium;height:70px;width:125px;border-radius: unset;"
													:class="{ 'gradient-background': InProcess_setGradient }"
													@click="cal_monthlyInProcess"
													>
													<h6 style="margin-bottom: 3px !important;">({{ All_InProcessCount }})</h6>
													<small class="text-muted" style="font-size: 11px;font-weight: bold;">Total In Process</small>
												</b-card>
											</template>
										</b-col>
										<b-col cols="2" lg="1" class="py-0" style="background-color: whitesmoke;border: 1px white;padding-left:0px;padding-right:0px;height:85px;margin-left:-23px !important;height:70px;width:125px;">
											<template>
												<b-card 
													class="text-center" 
													text-variant="black" 
													style="height:85px;box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);border-bottom-color: #8EA7DE;border-bottom-width: medium;height:70px;width:125px;border-radius: unset;"
													:class="{ 'gradient-background':  submitted_setGradient}"
													@click="cal_monthlySubmitted"
													>
													<h6 style="margin-bottom: 3px !important;">({{ All_SubmittedCount }})</h6>
													<p class="text-muted" style="font-size: 11px;font-weight: bold;width:max-content;margin-top:8px;">Total Submitted</p>
													<!-- <template #footer>
														
													</template> -->
												</b-card>
											</template>
										</b-col>
										<b-col cols="2" lg="2" class="py-0" style="background-color: whitesmoke; border: 1px white; padding-left: 0px; padding-right: 0px; margin-left: 52px; height: 70px; width: 125px;">
												<b-card 
													class="text-center" 
													text-variant="black" 
													style="height: 85px; box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1); border-bottom-color: green; border-bottom-width: medium; height: 70px; width: 125px;border-radius: unset;"
													:class="{ 'gradient-background': unassigned_setGradient }"
													@click="cal_monthlyUnassigned"
													>
													<h6 style="margin-bottom: 3px !important;">({{ All_UnassignedCount }})</h6>
													<p class="text-muted" style="font-size: 11px;font-weight: bold;width:max-content;margin-top:8px;">Total Unassigned</p>
												</b-card>
										</b-col>
										<b-col cols="2" lg="1" class="py-0" style="background-color: whitesmoke;border: 1px white;padding-left:0px;padding-right:0px;height:85px;margin-left:-24px !important;height:70px;width:125px;">
											<template>
												<b-card class="text-center" text-variant="black" style="height:85px;box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);border-bottom-color: #8EA7DE;border-bottom-width: medium;height:70px;width:125px;border-radius: unset;">
													<h6 style="margin-bottom: 3px !important;">(0)</h6>
													<small class="text-muted" style="font-size: 11px;font-weight: bold;">Hearing</small>
													<!-- <template #footer>
														
													</template> -->
												</b-card>
											</template>
										</b-col>
									</b-row>
								</b-col>
							</b-row>
							<b-row>
								<b-col cols="9" md="9" lg="9" xl="9" class="mb-4">
									<template style="margin-bottom: 24px;">
										<FullCalendar 
											ref="fullCalendar" 
											:options="calendarOptions" 
											style="margin-bottom: 24px;" 
										/>
									</template>
								</b-col>
								<b-col cols="3" md="3" lg="3" xl="3" class="mb-4" style="margin-top:57px;">
									<h6>{{ showTodayAppealStatus ? formattedClickedDate : clickedDate }}</h6>
									<hr style="margin-right:24px;margin-top:10px !important;">
									<!-- First element with v-if -->
									<p v-if="showCardInfo" style="margin-top:-8px !important;">
										<span style="font-size: 12px;">Unassigned- <h6 style="display: inline;">{{ monthlyUnassignedCount }}</h6></span><br>
										<span style="font-size: 12px;">In Process-<h6 style="display: inline;">{{ monthlyInProcessCount }}</h6></span><br>
										<span style="font-size: 12px;">Submitted-<h6 style="display: inline;">{{ monthlySubmittedCount }}</h6></span>
									</p>
									<p v-else-if="showTabInfo">
										<span style="font-size: 12px;">{{ tabText }}-<h6 style="display: inline;">{{ valueForInProcessAppeals }}</h6></span><br>
									</p>
									<!-- <p v-else>
										<span style="font-size: 12px;">In Process-<h6 style="display: inline;">{{ valueForInProcessAppeals }}</h6></span><br>
									</p> -->
								</b-col>
							</b-row>		
						</div>
					</b-card>

					<!-- <b-card no-body class="mb-4 shadow-sm">
						<b-card-header header-tag="header" role="tab" class="p-0 border-b-0">
							<b-button
								block
								@click="collapseNotes = !collapseNotes"
								variant="light"
								role="tab"
								class="text-left px-4 py-3 m-0 rounded-b-0"
							>
								<font-awesome-icon
									class="ml-0"
									:icon="collapseNotes ? 'chevron-down' : 'chevron-right'"
									fixed-width
								/>
								Recent Notes
							</b-button>
						</b-card-header>
						<b-collapse v-model="collapseNotes" role="tabpanel">
							<b-row>
								<b-col cols="12">
									<RecentNotes />
								</b-col>
							</b-row>
						</b-collapse>
					</b-card> -->

					
					<!-- <b-card no-body class="mb-4 shadow-sm">
						<paginated-results
							v-slot="{
								empty,
								hasMultiplePages,
								hasNextPage,
								hasPrevPage,
								loading,
								nextPage,
								prevPage,
								page,
								pages,
								results,
								total,
							}"
							v-bind="{
								action: getAppealQueue,
								perPage: queuePerPage,
								filters,
							}"
						>
							<b-card-header
								header-tag="header"
								header-bg-variant="primary"
								role="tab"
								class="p-0 border-b-0"
							>
								<b-button
									block
									@click="collapseMyAppeals = !collapseMyAppeals"
									variant="primary"
									role="tab"
									class="text-left px-4 py-3 m-0 font-weight-bold"
								>
									<font-awesome-icon
										class="ml-0"
										:icon="collapseMyAppeals ? 'chevron-down' : 'chevron-right'"
										fixed-width
									/>

									<span>My Appeals</span>
									<b-badge v-if="total > 0" pill variant="danger" class="ml-3">
										{{ total }}
									</b-badge>
								</b-button>
							</b-card-header>
							<b-collapse v-model="collapseMyAppeals" role="tabpanel">
								<b-card-header v-if="!empty && hasMultiplePages" class="text-right">
									<b-row class="d-flex justify-content-between align-items-center">
										<b-col cols="4" class="text-left">
											<p class="font-weight-bold small text-muted mb-0">
												Page {{ page }} / {{ pages }}
											</p>
										</b-col>
										<b-col cols="8" class="text-right">
											<simple-pagination
												v-bind="{ loading, prevPage, hasPrevPage, nextPage, hasNextPage }"
											/>
										</b-col>
									</b-row>
								</b-card-header>

								<loading-indicator v-if="loading && empty" class="my-5" />
								<b-list-group flush v-else-if="!empty">
									<table class="table table-hover  table-striped ">
										<thead>
											<tr >
												<th class="w-10 text-center"><small class="th">Patient Name</small></th>											
												<th class="w-10 text-center"><small class="th">Facility</small></th>
												<th class="w-10 text-center"><small class="th">Insurance Provider</small></th>
												<th class="w-10 text-center"><small class="th">Level</small></th>
												<th class="w-6 text-center"><small  class="th">Priority</small></th>
												<th class="w-10 text-center"><small class="th">Due Date</small></th>
											</tr>
										</thead>
										<tbody>
											<router-link v-for="result in results" :key="result.id" :to="{ name: 'appeals.view', params: { id: result.case_id, appeal_id: result.id }}" tag="tr" >
												<td class="text-center  align-middle" :class="{ 'py-0': result.case.patient.full_name && result.case.patient.full_name.length > 12 }">
														<span v-if="result?.case?.patient" class="font-weight-bold">
															{{ result.case.patient.full_name }}
														</span>
														<span v-else class="text-danger">
															Missing Patient Name
														</span>
													</td>

													<td class="text-center  align-middle" :class="{ 'py-0': result.case.facility.name && result.case.facility.name.length > 12 }">
														<span v-if="result.case?.facility?.name">
															{{ result.case.facility.name.substring(0, 20) }}
														</span>
													</td>

													<td class="text-center  align-middle" :class="{ 'py-0': result.case.insurance_provider.name && result.case.insurance_provider.name.length > 12 }">
														<span v-if="result.case?.insurance_provider?.name">
															{{ result.case.insurance_provider.name.substring(0, 15) }}
														</span>
													</td>

													<td class="text-center  align-middle" :class="{ 'py-0': result.appeal_level?.name && result.appeal_level?.name.length > 12 }">
														<span v-if="result.appeal_level?.name">
															{{ result.appeal_level?.name.substring(0, 12) }}
														</span>
														<span v-else>
															&mdash;
														</span>
													</td>

												<td class="text-center py-0 align-middle">
													<span v-if="result.priority" class="font-weight-bold text-primary text-center">
														<font-awesome-icon icon="check-circle" class="text-success"  />
														</span>
														<span v-else class="text-center">
															&mdash;
														</span>
												</td>
												<td class="text-center py-0 align-middle">
													<span v-if="result.due_date">
														<span :class="{
																'text-danger font-weight-bold': result.is_overdue,
																'text-dark font-weight-bold': isDueToday(result.due_date),
																'text-dark': !result.is_overdue && !isDueToday(result.due_date)
															}">
														 {{$filters.formatDate(result.due_date)}}	 {{ isDueToday(result.due_date) ? 'Due Today' : isDueInFuture(result.due_date) ? 'Due in ' + daysUntilDue(result.due_date) + ' days' : daysAgo(result.due_date) + ' days ago' }} 
														</span>
														</span>
												</td>
											</router-link>
										</tbody>
									</table>


								</b-list-group>
								<empty-result v-else-if="empty" icon="check-circle">
									No appeals assigned
									<template #content>
										<p class="mb-0">No open appeals are assigned to you at this time.</p>
										<p class="mb-0">You're all caught up!</p>
									</template>
								</empty-result>
							</b-collapse>
						</paginated-results>
					</b-card>
					<b-card no-body class="mb-4">
						<paginated-results
							v-slot="{
								empty,
								hasMultiplePages,
								hasNextPage,
								hasPrevPage,
								loading,
								nextPage,
								prevPage,
								page,
								pages,
								results,
								total,
							}"
							v-bind="{
								action: getRequestQueue,
								perPage: queuePerPage,
							}"
						>
							<b-card-header
								header-tag="header"
								header-bg-variant="primary"
								role="tab"
								class="p-0 border-b-0"
							>
								<b-button
									block
									@click="collapseMyRequests = !collapseMyRequests"
									variant="primary"
									role="tab"
									class="text-left px-4 py-3 m-0 font-weight-bold"
								>
									<font-awesome-icon
										class="ml-0"
										:icon="collapseMyRequests ? 'chevron-down' : 'chevron-right'"
										fixed-width
									/>
									<span>My Submission</span>
									<b-badge v-if="outgoinglength" pill variant="danger" class="ml-3">
										{{ outgoinglength }}
									</b-badge>
								</b-button>
							</b-card-header>
							<b-collapse v-model="collapseMyRequests" role="tabpanel">
								<b-card-header v-if="!empty && hasMultiplePages" class="text-right">
									<b-row class="d-flex justify-content-between align-items-center">
										<b-col cols="4" class="text-left">
											<p class="font-weight-bold small text-muted mb-0">
												Page {{ page }} / {{ pages }}
											</p>
										</b-col>
										<b-col cols="8" class="text-right">
											<simple-pagination
												v-bind="{ loading, prevPage, hasPrevPage, nextPage, hasNextPage }"
											/>
										</b-col>
									</b-row>
								</b-card-header>

								<loading-indicator v-if="loading && emptyy" class="my-5" />
								<div v-else-if="!emptyy">
                					<table class="table  table-hover">
										<thead>
											<tr class="text-center">
												
												
												<th>Patient Name</th>
												<th>Facility</th>
												<th>Level</th>
												<th>Sent Date</th>
												<th>Estimated Date</th>
											</tr>
										</thead>
										<tbody>
											<tr v-for="(item, index) in myoutgoing" :key="index" v-if="item.status_message === 'NEW'" @click="$router.push({ name: 'outgoingDocuments' })">
												<td class="text-center">{{ item.case.patient.first_name }} {{ item.case.patient.last_name }}</td>
												<td class="text-center">{{ item.case.facility.name }}</td>
												<td class="text-center">{{ item.appeal.insurance_provider_appeal_level ? item.appeal.insurance_provider_appeal_level.label : '&mdash;' }}</td>
												<td class="text-center">{{ $filters.formatDate(item.sent_date_time) }}</td>
												<td class="text-center">{{$filters.formatDate(
										new Date(new Date(item.sent_date_time).getTime() + 
										(item.appeal && item.appeal.insurance_provider_appeal_level && item.appeal.insurance_provider_appeal_level.max_days ? 
										item.appeal.insurance_provider_appeal_level.max_days * 24 * 60 * 60 * 1000 : 
										0))
									) }}</td>
											</tr>
										</tbody>
									</table>
            					</div>
								<empty-result v-else-if="emptyy" icon="check-circle">
									No requests assigned
									<template #content>
										<p class="mb-0">No open requests are assigned to you at this time.</p>
										<p class="mb-0">You're all caught up!</p>
									</template>
								</empty-result>
							</b-collapse>
						</paginated-results>
					</b-card> -->
				</b-col>
				<b-col cols="12" md="6" lg="5" xl="5" class="mb-4">
						
					<!-- <b-card-group class="shadow-sm mb-4">
						<b-card class="text-center p-1">
							<p class="h4 font-weight-bold mb-1">
								<span v-if="!openClaimsTotal" class="text-muted">&mdash;</span>
								<span v-else class="mx-0 px-0">
									
									{{openCases}}
								</span>
							</p>
							<p class="small text-muted mb-0">Open Cases</p>
							<p class="smaller-text-muted text-muted">(total no.)</p>
						</b-card>
						<b-card class="text-center p-1">
							<p class="h4 font-weight-bold mb-1">
								<span v-if="!openClaimsTotal" class="text-muted">&mdash;</span>
								<span v-else class="mx-0 px-0">
									
									${{totalCasesClaimData}}K
								</span>
							</p>
							<p class="small text-muted mb-0">Open Cases</p>
							<p class="smaller-text-muted text-muted">(total risk amount)</p>
						</b-card>
						<b-card class="text-center p-1">
							<p class="h4 font-weight-bold mb-1">
								<span v-if="!openClaimsTotal" class="text-muted">&mdash;</span>
								<span v-else>
									
									{{ closedCases }}
								</span>
							</p>
							<p class="small text-muted mb-0">Closed Cases</p>
							<p class="smaller-text-muted text-muted">(total no.)</p>
						</b-card>
						
					</b-card-group> -->
					<div class="section-box">
						<h5 class="text-muted">{{currentMonth}}</h5>
					</div>
					<!-- <b-card-group class="shadow-sm mb-4">
						<b-card class="text-center p-1 custom-card">
							<p class="h4 font-weight-bold mb-1">
								<span v-if="!openClaimsTotal" class="text-muted">&mdash;</span>
								<span v-else class="mx-0 px-0">
						
									{{newCaseNum}}
								</span>
							</p>
							<p class="small text-muted mb-0">New Cases1</p>
							<p class="smaller-text-muted text-muted">(total no.)</p>
						</b-card>
						<b-card class="text-center p-1 custom-card">
							<p class="h4 font-weight-bold mb-1">
								<span v-if="!openClaimsTotal" class="text-muted">&mdash;</span>
								<span v-else class="mx-0 px-0">
								
									{{toalCaseClaims}}
								</span>
							</p>
							<p class="small text-muted mb-0">New Cases</p>
							<p class="smaller-text-muted text-muted">(total risk amount)</p>
						</b-card>
						<b-card class="text-center p-1 custom-card">
							<p class="h4 font-weight-bold mb-1">
								<span v-if="!openClaimsTotal" class="text-muted">&mdash;</span>
								<span v-else>
									
									{{ $filters.formatNumber(openAppealCount) }}
								</span>
							</p>
							<p class="small text-muted mb-0">In-process Appeals</p>
							<p class="smaller-text-muted text-muted">(total no.)</p>
						</b-card>
						
						<b-card class="text-center p-1 custom-card">
							<p class="h4 font-weight-bold mb-1">
								<span v-if="!openClaimsTotal" class="text-muted">&mdash;</span>
								<span v-else class="mx-0 px-0">
									
									{{ totalSubmittedAppeals }}
								</span>
							</p>
							<p class="small text-muted mb-0">Submitted Appeals</p>
							<p class="smaller-text-muted text-muted">(total no.)</p>
						</b-card> 
						
					</b-card-group> -->
					<!--<b-card-group class="shadow-sm mb-4">
					 <b-card class="text-center p-1 smaller-card">
						<p class="h5 font-weight-bold mb-1">
							<span v-if="!openClaimsTotal" class="text-muted">&mdash;</span>
							<span v-else class="mx-0 px-0">
								{{newCaseNum}}
							</span>
						</p>
						<p class="smaller-text-muted text-muted mb-0">New Cases (total no.)</p>
					</b-card>
					<b-card class="text-center p-1 smaller-card">
						<p class="h5 font-weight-bold mb-1">
							<span v-if="!openClaimsTotal" class="text-muted">&mdash;</span>
							<span v-else class="mx-0 px-0">
								{{toalCaseClaims}}
							</span>
						</p>
						<p class="smaller-text-muted text-muted mb-0">New Cases (total risk amount)</p>
					</b-card>
					<b-card class="text-center p-1 smaller-card">
						<p class="h5 font-weight-bold mb-1">
							<span v-if="!openClaimsTotal" class="text-muted">&mdash;</span>
							<span v-else>
								{{ $filters.formatNumber(openAppealCount) }}
							</span>
						</p>
						<p class="smaller-text-muted text-muted mb-0">In-process Appeals (total no.)</p>
					</b-card>
					<b-card class="text-center p-1 smaller-card">
						<p class="h5 font-weight-bold mb-1">
							<span v-if="!openClaimsTotal" class="text-muted">&mdash;</span>
							<span v-else class="mx-0 px-0">
								{{ totalSubmittedAppeals }}
							</span>
						</p>
						<p class="smaller-text-muted text-muted mb-0">Submitted Appeals (total no.)</p>
					</b-card>
					</b-card-group> -->
					<!-- <b-card-group class="shadow-sm mb-4">
						<b-card class="text-center p-1 smaller-card col-lg-3 col-md-6 col-sm-12">
							<p class="h5 font-weight-bold mb-1">
								<span v-if="!openClaimsTotal" class="text-muted">&mdash;</span>
								<span v-else class="mx-0 px-0">
									{{newCaseNum}}
								</span>
							</p>
							<p class="small-text-muted text-muted mb-0">New Cases</p>
							 <p class="smaller-text-muted text-muted">(total no.)</p> 
						</b-card>
						<b-card class="text-center p-1 smaller-card col-lg-3 col-md-6 col-sm-12">
							<p class="h5 font-weight-bold mb-1">
								<span v-if="!openClaimsTotal" class="text-muted">&mdash;</span>
								<span v-else class="mx-0 px-0">
									${{toalCaseClaims}}K
								</span>
							</p>
							<p class="small-text-muted text-muted mb-0">New Cases</p>
							<p class="smaller-text-muted text-muted">(risk amount)</p>
						</b-card>
						<b-card class="text-center p-1 smaller-card col-lg-3 col-md-6 col-sm-12">
							<p class="h5 font-weight-bold mb-1">
								<span v-if="!openClaimsTotal" class="text-muted">&mdash;</span>
								<span v-else>
									{{ $filters.formatNumber(openAppealCount) }}
								</span>
							</p>
							<p class="small-text-muted text-muted mb-0">In-process Appeals</p>
							<p class="smaller-text-muted text-muted">(total no.)</p> 
						</b-card>
						<b-card class="text-center p-1 smaller-card col-lg-3 col-md-6 col-sm-12">
							<p class="h5 font-weight-bold mb-1">
								<span v-if="!openClaimsTotal" class="text-muted">&mdash;</span>
								<span v-else class="mx-0 px-0">
									{{ totalSubmittedAppeals }}
								</span>
							</p>
							<p class="small-text-muted text-muted mb-0">Submitted Appeals</p>
							<p class="smaller-text-muted text-muted">(total no.)</p> 
						</b-card>
					</b-card-group> -->
					<b-card-group class="shadow-sm mb-4">
						<b-card class="text-center p-1 smaller-card col-lg-3 col-md-6 col-sm-12 newCaseNum">
							<p class="h5 font-weight-bold mb-1">
								<span v-if="newCaseNum==0" class="text-muted">&mdash;</span>
								<span v-else class="mx-0 px-0">
									{{newCaseNum}}
								</span>
							</p>
							<p class="small-text-muted text-muted mb-0">New Cases</p>
						</b-card>
						<b-card class="text-center p-1 smaller-card col-lg-3 col-md-6 col-sm-12 toalCaseClaims">
							<p class="h5 font-weight-bold mb-1">
								<span v-if="toalCaseClaims ==0" class="text-muted">&mdash;</span>
								<span v-else class="mx-0 px-0">
									${{toalCaseClaims}}
								</span>
							</p>
							<p class="small-text-muted text-muted mb-0">New Cases</p>
							<p class="smaller-text-muted text-muted">(Risk Amount)</p>
						</b-card>
						<b-card class="text-center p-1 smaller-card col-lg-3 col-md-6 col-sm-12 openAppealCount openAppealCount">
							<p class="h5 font-weight-bold mb-1">
								<span v-if="$filters.formatNumber(openAppealCount) == 0" class="text-muted">&mdash;</span>
								<span v-else>
									{{ $filters.formatNumber(openAppealCount) }}
								</span>
							</p>
							<p class="small-text-muted text-muted mb-0">In-process Appeals</p>
						</b-card>
						<b-card class="text-center p-1 smaller-card col-lg-3 col-md-6 col-sm-12 totalSubmittedAppeals">
							<p class="h5 font-weight-bold mb-1">
								<span v-if="totalSubmittedAppeals==0" class="text-muted">&mdash;</span>
								<span v-else class="mx-0 px-0">
									{{ totalSubmittedAppeals }}
								</span>
							</p>
							<p class="small-text-muted text-muted mb-0">Submitted Appeals</p>
						</b-card>
					</b-card-group>



					<!-- <b-card-group class="shadow-sm mb-4">
						<b-card class="text-center p-1">
							<p class="h4 font-weight-bold mb-1">
								<span v-if="!openClaimsTotal" class="text-muted">&mdash;</span>
								<span v-else class="mx-0 px-0">
									
									${{toalCaseClaims}}K
								</span>
							</p>
							<p class="small text-muted mb-0">New Cases</p>
							<p class="smaller-text-muted text-muted">(Amount)</p>
						</b-card>
						<b-card class="text-center p-1">
							<p class="h4 font-weight-bold mb-1">
								<span v-if="!openClaimsTotal" class="text-muted">&mdash;</span>
								<span v-else class="mx-0 px-0">
									
									${{recentReiumbersedAmt}}K
								</span>
							</p>
							<p class="small text-muted mb-0">Paid/Partial</p>
							<p class="smaller-text-muted text-muted">(Amount)</p>
						</b-card>
						<b-card class="text-center p-1">
							<p class="h4 font-weight-bold mb-1">
								<span v-if="!openClaimsTotal" class="text-muted">&mdash;</span>
								<span v-else>
									
									${{ recentPaid }}K
								</span>
							</p>
							<p class="small text-muted mb-0">Write Off</p>
						</b-card>
						
					</b-card-group> -->

					<b-card no-body header-class="d-flex justify-content-between align-items-center mb-4">
						<b-tabs card>
							<!-- <b-tab no-body>
								<template #title>
									<span>Overview</span>
								</template>
								<b-card-body>
									<b-row>
										<b-col cols="12" class="mb-4">
											<AppealsLineChart height="300px" />
										</b-col>
									</b-row>
									<b-row>
										<b-col cols="12" xl="6">
											<b-row class="mt-4 mt-xl-4">
												<b-col cols="4" md="4" lg="6" xl="6" class="mb-4 mb-xl-4 text-center">
													<p class="h5 mb-0 font-weight-bold">
														{{ $filters.formatNumber(openCaseCount)}}
													</p>
													<p class="text-muted mb-0">Open Cases</p>
												</b-col>
												<b-col cols="4" md="4" lg="6" xl="6" class="mb-4 mb-xl-4 text-center">
													<p class="h5 mb-0 font-weight-bold">
														{{ $filters.formatNumber(openAppealCount) }}
													</p>
													<p class="text-muted mb-0">Open Appeals</p>
												</b-col>
												<b-col cols="4" md="4" lg="6" xl="6" class="mb-4 mb-xl-4 text-center">
													<p class="h5 mb-0 font-weight-bold">
														{{ $filters.formatNumber(openCaseRequestCount) }}
													</p>
													<p class="text-muted mb-0">Open Requests</p>
												</b-col>
												<b-col cols="4" md="4" lg="6" xl="6" class="mb-4 mb-xl-4 text-center">
													<p class="h5 mb-0 font-weight-bold">
														{{ $filters.formatNumber(assignedDocuments) }}
													</p>
													<p class="text-muted mb-0">Assigned Documents</p>
												</b-col>
												<b-col cols="4" md="4" lg="6" xl="6" class="mb-4 mb-xl-4 text-center">
													<p class="h5 mb-0 font-weight-bold">
														{{ $filters.formatNumber(unassignedAppeals) }}
													</p>
													<p class="text-muted mb-0">Unassigned Appeals</p>
												</b-col>
												<b-col cols="4" md="4" lg="6" xl="6" class="mb-4 mb-xl-4 text-center">
													<p class="h5 mb-0 font-weight-bold">
														{{ $filters.formatNumber(emptyCases) }}
													</p>
													<p class="text-muted mb-0">Empty Cases</p>
												</b-col>
											</b-row>
										</b-col>
										<b-col cols="12" xl="6">
											<CasesBarChart height="300px" />
										</b-col>
									</b-row>
								</b-card-body>
								<b-card-footer class="text-right">
									<b-button :to="{ name: 'reports' }" title="Reports" size="sm">
										View Reports
										<font-awesome-icon icon="chevron-right" />
									</b-button>
								</b-card-footer>
							</b-tab> -->
							<!-- <b-tab no-body>
								<template #title>
									<span>Users Online</span>
								</template>
								<b-list-group 
									flush 
									v-if="usersOnline.length > 0" 
									style="max-height: 400px; overflow-y: auto;"
								>
									<b-list-group-item
									v-for="user in usersOnline"
									:key="user.id"
									:to="{ name: 'users.view', params: { id: user.id } }"
									class="d-flex justify-content-between align-items-center py-3"
									title="View User"
									>
									<div class="d-flex justify-start align-items-center">
										<b-avatar
										rounded
										:variant="currentUserId == user.id ? 'primary' : 'light'"
										class="mr-3 px-0 text-center"
										>
										<font-awesome-icon icon="user" class="px-0 mx-0" />
										</b-avatar>
										<div>
										<h6 class="h6 font-weight-bold mb-0">
											{{ user.full_name }}
										</h6>
										<p class="small text-muted mb-0">
											{{ user.email }}
										</p>
										</div>
									</div>
									<font-awesome-icon icon="chevron-right" fixed-width />
									</b-list-group-item>
								</b-list-group>
								<empty-result v-else>
									No users online
									<template #content>
									No other users from your organization are active right now.
									</template>
								</empty-result>
							</b-tab> -->
							<b-tab no-body>
								<template #title>
									<span>Users Online</span>
								</template>
								<b-list-group 
									flush 
									v-if="usersOnline.length > 0" 
									style="max-height: 370px; overflow-y: auto;"
								>
									<b-list-group-item
									v-for="user in usersOnline"
									:key="user.id"
									:to="{ name: 'users.view', params: { id: user.id } }"
									class="d-flex justify-content-between align-items-center py-3"
									title="View User"
									>
									<div class="d-flex justify-start align-items-center">
										<b-avatar
										rounded
										:variant="currentUserId == user.id ? 'primary' : 'light'"
										class="mr-3 px-0 text-center"
										>
										<font-awesome-icon icon="user" class="px-0 mx-0" />
										</b-avatar>
										<div>
										<h6 class="h6 font-weight-bold mb-0">
											{{ user.full_name }}
										</h6>
										<p class="small text-muted mb-0">
											{{ user.email }}
										</p>
										</div>
									</div>
									<font-awesome-icon icon="chevron-right" fixed-width />
									</b-list-group-item>
								</b-list-group>
								<empty-result v-else>
									No users online
									<template #content>
									No other users from your organization are active right now.
									</template>
								</empty-result>
							</b-tab>

							<!-- <b-tab no-body lazy>
								<template #title>
									<span>Search Patients</span>
								</template>
								<PatientSearchInput autofocus v-model="patient" class="mx-3 my-3" />
								<b-card-body v-if="patient && patient.list_name" class="pt-0">
									<dl class="mb-0">
										<div class="row" v-if="patient.date_of_birth">
											<dt class="col-5 text-muted h6 small">DOB</dt>
											<dd class="col-7">
												<font-awesome-icon
													icon="birthday-cake"
													:class="patient.is_birthday ? 'text-primary' : 'text-muted'"
													:title="patient.is_birthday ? 'Happy Birthday' : 'Date of Birth'"
												/>

												<span class="font-weight-bold">
													{{ $filters.formatDate(patient.date_of_birth) }}
												</span>
												<span v-if="patient.age != null && patient.age != undefined">
													&mdash;
													<span class="font-weight-bold" v-text="patient.age" />
												</span>
											</dd>
										</div>

										<div class="row" v-if="patient.sex">
											<dt class="col-5 text-muted h6 small">Gender</dt>
											<dd class="col-7">
												<span v-if="patient.sex">
													{{ patient.sex }}
												</span>
											</dd>
										</div>
										<div class="row" v-if="patient.marital_status">
											<dt class="col-5 text-muted h6 small">Marital Status</dt>
											<dd class="col-7">
												<span v-if="patient.marital_status">
													{{ patient.marital_status }}
												</span>
											</dd>
										</div>
										<div v-if="patient.phone" class="row">
											<dt class="col-5 text-muted h6 small">Phone</dt>
											<dd class="col-7">
												{{ $filters.formatPhone(patient.phone) }}
											</dd>
										</div>
										<div v-if="patient.fax" class="row">
											<dt class="col-5 text-muted h6 small">Fax</dt>
											<dd class="col-7">
												{{ $filters.formatPhone(patient.fax) }}
											</dd>
										</div>
										<div v-if="patient.email" class="row">
											<dt class="col-5 text-muted h6 small">Email</dt>
											<dd class="col-7">
												<a :href="'mailto:' + patient.email">{{ patient.email }}</a>
											</dd>
										</div>
										<div v-if="patient.full_address" class="row">
											<dt class="col-5 text-muted h6 small">Address</dt>
											<dd class="col-7">
												<div class="white-space-pre" v-text="patient.full_address" />
											</dd>
										</div>
										<div v-if="patient.modified" class="row">
											<dt class="col-5 text-muted h6 small">Last Updated</dt>
											<dd class="col-7">{{ $filters.fromNow(patient.modified) }}</dd>
										</div>
									</dl>
								</b-card-body>
								<div v-if="patient && patient.id">
									<h6 class="h6 text-muted text-uppercase font-weight-bold mx-2">Cases</h6>
									<case-index
										ref="caseList"
										:filters="{ patient_id: patient.id }"
										@clicked="viewCase"
										hide-patient
										empty-description="No cases have been created for this patient."
									/>
								</div>
								<b-card-footer v-if="patient && patient.list_name">
									<div class="d-flex justify-content-between align-items-center">
										<b-button
											variant="secondary"
											:to="{ name: 'patients.edit', params: { id: patient.id } }"
										>
											<font-awesome-icon icon="edit" fixed-width />
											Edit
										</b-button>

										<b-button
											variant="primary"
											:to="{ name: 'patients.view', params: { id: patient.id } }"
										>
											View Patient
											<font-awesome-icon icon="chevron-right" />
										</b-button>
									</div>
								</b-card-footer>
							</b-tab> -->
							<b-tab no-body>
								<template #title>
									<span>User Queues</span>
								</template>
								<loading-indicator v-if="loadingAppealsOpenByAssignedUser" class="my-5" />
								<b-list-group v-else flush>
									<b-list-group-item
										v-for="user in limitedAppealsOpenByAssignedUser"
										:key="user.id"
										:to="{ name: 'users.view', params: { id: user.id } }"
										class="d-flex justify-content-between align-items-center"
										:variant="user.count && user.count > 0 ? '' : 'light'"
									>
										<p class="mb-0" :class="user.count && user.count > 0 ? 'font-weight-bold' : ''">
											{{ user.full_name }}
										</p>
										<b-badge pill :variant="user.count && user.count > 0 ? 'primary' : 'light'">
											{{ user.count }}
										</b-badge>
									</b-list-group-item>
								</b-list-group>
							</b-tab>
						</b-tabs>
					</b-card>
				</b-col>
			</b-row>
			<!-- <b-row>
				<b-col>
					<iframe title="sample test" width="1140" height="541.25" src="https://app.powerbi.com/reportEmbed?reportId=ca31633d-ff0e-4e4f-8207-db256873bed0&autoAuth=true&ctid=5b5e4346-86c0-41e2-baf0-163a47f0d520" 
					frameborder="0" allowFullScreen="true"></iframe>
				</b-col>
			</b-row> -->
			<b-row>
				<b-col cols="12">
					<b-card no-body class="mb-4 shadow-sm">
							<paginated-results
							v-slot="{
								empty,
								hasMultiplePages,
								hasNextPage,
								hasPrevPage,
								loading,
								nextPage,
								prevPage,
								page,
								pages,
								total,
							}"
							v-bind="{ action: getAppealQueue, perPage: queuePerPage }"
							>
							<b-card-header
								header-tag="header"
								header-bg-variant="primary"
								role="tab"
								class="p-0 border-b-0"
							>
								<b-button
								block
								@click="collapseMyAppeals = !collapseMyAppeals"
								variant="primary"
								role="tab"
								class="text-left px-4 py-3 m-0 font-weight-bold"
								>
								<font-awesome-icon
									class="ml-0"
									:icon="collapseMyAppeals ? 'chevron-down' : 'chevron-right'"
									fixed-width
								/>
								<span>My Appeals</span>
								<b-badge v-if="appeallength > 0" pill variant="info" class="ml-3">
									{{ appeallength }}
								</b-badge>
								</b-button>
							</b-card-header>
							<b-collapse v-model="collapseMyAppeals" role="tabpanel">
								<b-card-header v-if="appeallength > itemsPerPage" class="text-right">
								<b-row class="d-flex justify-content-between align-items-center">
									<b-col cols="4" class="text-left">
									<p class="font-weight-bold small text-muted mb-0">
										Page {{ currentPag }} / {{ totalappealpages }}
									</p>
									</b-col>
									<b-col cols="8" class="text-right">
									<b-button-group>
										<b-button @click="prevPagee" title="Previous Page" :disabled="currentPag === 1">
										<font-awesome-icon icon="chevron-left" fixed-width />
										<span class="d-none d-sm-inline">Prev</span>
										</b-button>
										<b-button @click="nextPagee" title="Next Page" :disabled="currentPag * itemsPerPage >= appeallength">
										<span class="d-none d-sm-inline">Next</span>
										<font-awesome-icon icon="chevron-right" fixed-width />
										</b-button>
									</b-button-group>
									</b-col>
								</b-row>
								</b-card-header>
								<loading-indicator v-if="isLoading && isFirstLoadAppeal" class="my-5" />

								<div class="responsive-table-wrapper">
                                <div class="responsive-table">
								<b-table
									striped hover
									:items="myResults"
									:fields="fields"
									:per-page="8"
									:current-page="currentPag"
									:sort-by.sync="sortBy"
									:sort-desc.sync="sortDesc"
									@sort-changed="sortChanged"
									@row-clicked="onRowClick"
									v-if="myResults.length > 0"
									 class="custom-table"
									>
									<template #cell(id)="data">
										<span class="d-flex justify-content-between align-items-center"  v-if="data.item.request_type === 'DOCUMENTATION' || data.item.request_type === 'HEARING' || data.item.request_type === 'MedicalRecord'">{{ data.item.appeal_level }}  
											
											<svg v-if="data.item.urgent" xmlns="http://www.w3.org/2000/svg" id="Layer_1" data-name="Layer 1" viewBox="0 0 24 24" width="23" height="16" fill="#ff5252">
  												<path d="M13,2.051V1a1,1,0,0,0-2,0V2.051A10.98,10.98,0,0,0,3.681,20.176,3.024,3.024,0,0,0,2,23a1,1,0,0,0,2,0,1.2,1.2,0,0,1,1.11-1.229.932.932,0,0,0,.2-.062,10.924,10.924,0,0,0,13.39,0,1.033,1.033,0,0,0,.182.064A1.2,1.2,0,0,1,20,23a1,1,0,0,0,2,0,3.024,3.024,0,0,0-1.681-2.824A10.98,10.98,0,0,0,13,2.051ZM3,13a9,9,0,1,1,9,9A9.011,9.011,0,0,1,3,13Z"/>
  												<path d="M19.215,0a1,1,0,0,0,0,2A2.59,2.59,0,0,1,22,4.5a1,1,0,0,0,2,0A4.6,4.6,0,0,0,19.215,0Z"/>
  												<path d="M2,4.5A2.59,2.59,0,0,1,4.785,2a1,1,0,0,0,0-2A4.6,4.6,0,0,0,0,4.5a1,1,0,0,0,2,0Z"/>
  												<path d="M13,11.586V7a1,1,0,0,0-2,0v5a1,1,0,0,0,.293.707l3,3a1,1,0,0,0,1.414-1.414Z"/>
											</svg>
											<span v-if="data.item.unable_to_complete" class="badge badge-warning badge-pill">
												<svg 
        											aria-hidden="true" 
        											focusable="false" 
        											data-prefix="fas" 
        											data-icon="triangle-exclamation" 
        											role="img" 
        											xmlns="http://www.w3.org/2000/svg" 
        											viewBox="0 0 512 512" 
        											class="svg-inline--fa fa-triangle-exclamation" 
        											style="width: 10px; height: 10px; margin-right: 5px;display: inline-block;">
        											<path fill="currentColor" d="M256 32c14.2 0 27.3 7.5 34.5 19.8l216 368c7.3 12.4 7.3 27.7 .2 40.1S486.3 480 472 480H40c-14.3 0-27.6-7.7-34.7-20.1s-7-27.8 .2-40.1l216-368C228.7 39.5 241.8 32 256 32zm0 128c-13.3 0-24 10.7-24 24V296c0 13.3 10.7 24 24 24s24-10.7 24-24V184c0-13.3-10.7-24-24-24zm32 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"></path>
    										</svg>
										
										</span>
										<span v-if="data.item.request_type === 'MedicalRecord'"> 
												<span v-if="data.item.mr_status === '1'" :class="{'circle-badge-green': true}">
  												MR 
											</span>
											<span v-if="data.item.status !== '1'" :class="{'circle-badge': true}">
  												MR
												
												
											</span>
											</span>
											
											<span v-if="data.item.isRequest === 'DOCUMENTATION' || data.item.isRequest === 'HEARING'"> 
    										<span class="circle-badge">R</span>
											</span>
											<span v-if="data.item.hasRequest === 'true'"> 
												<span class="circle-badge">OR</span>
											</span>
										</span>
										<span class="d-flex justify-content-between align-items-center" v-else>{{ data.item.id }}  
											<span v-if="data.item.request_type === 'MedicalRecord'"> 
												<span v-if="data.item.status === '1'" :class="{'circle-badge-green': true}">
  												MR
											</span>
											<span v-if="data.item.status !== '1'" :class="{'circle-badge': true}">
  											MR
											</span>

											</span>
											<span v-if="data.item.request_type === 'DOCUMENTATION' || data.item.isRequest === 'HEARING'"> 
    										<span class="circle-badge">R</span>
											</span>
											<span v-if="data.item.hasRequest === 'true'"> 
												<span class="circle-badge">OR</span>
											</span>
										</span>
										
									</template>
									<template #cell(case.patient.full_name)="data">
                                        <span v-if="data.item.case && data.item.case.patient && data.item.case.patient.full_name " :title="data.item.case.patient.full_name">
                                               {{ data.item.case.patient.full_name }}
										</span>
										<span v-else>
                                              &mdash;
										</span>
									</template>
									<template #cell(case.admit_date)="data">
													<span v-if="data.item.case.admit_date">{{ $filters.formatDate(data.item.case.admit_date) }}</span>
													<span v-else>&mdash;</span>
									</template>
									<template #cell(case.discharge_date)="data">
  									<!-- Check if 'case' exists and 'discharge_date' is available -->
  									<span v-if="data.item.case && data.item.case.discharge_date">
    									{{ $filters.formatDate(data.item.case.discharge_date) }}
  										</span>
  									<span v-else>&mdash;</span> <!-- Show &mdash; if 'discharge_date' is missing -->
									</template>
										<!-- Facility Name Column -->
										<template #cell(case.facility.name)="data">
										
											<span v-if="data.item.case && data.item.case.facility && data.item.case.facility.name" :title="data.item.case.facility.name">
											{{ data.item.case.facility.name }}
											</span>
											<span v-else>&mdash;</span>
									
										</template>

										<!-- Facility Bill Type Column -->
										<template #cell(case.facility.bill_type)="data">
										
											<span v-if="data.item.case && data.item.case.facility && data.item.case.facility.bill_type">
											{{ data.item.case.facility.bill_type }}
											</span>
											<span v-else>&mdash;</span>
										
										</template>

										<!-- Insurance Provider Column -->
										<template #cell(case.insurance_provider.name)="data">
										
											<span v-if="data.item.case && data.item.case.insurance_provider && data.item.case.insurance_provider.name" :title=" data.item.case.insurance_provider.name">
											{{ data.item.case.insurance_provider.name }}
											</span>
											<span v-else>&mdash;</span>
										
										</template>

										<!-- Insurance Provider Appeal Level Column -->
										<template #cell(insurance_provider_appeal_level.label)="data">
											<span v-if="data.item.is_rebill">{{ data.item.rebill_label }}</span>
											<span v-else-if="data.item.insurance_appeal_id && data.item.insurance_provider_appeal_level.label">
											{{ data.item.insurance_provider_appeal_level.label }}
											</span>
											<span v-else>&mdash;</span>
										
										</template>

									<!-- Due Date Column -->
										<template #cell(due_date)="data">
											<span v-if="data.item.due_date">
												<span :style="{ color: data.item.is_overdue }" class="font-weight-bold">
												{{ $filters.formatDate(data.item.due_date) }}
												</span>
											</span>
											<span v-else>&mdash;</span>
										</template>


										<!-- Priority Column -->
										<template #cell(priority)="data">
										
											<span v-if="data.item.priority" class="font-weight-bold text-primary text-center">
											<font-awesome-icon icon="check-circle" class="text-success" />
											</span>
											<span v-else>&mdash;</span>
										
										</template>
									</b-table>
									</div>
								</div>
								<empty-result v-if="appeallength === 0" icon="check-circle">
								No appeals assigned
								<template #content>
									<p class="mb-0">No open appeals are assigned to you at this time.</p>
									<p class="mb-0">You're all caught up!</p>
								</template>
								</empty-result>
							</b-collapse>
							</paginated-results>
						</b-card>
						<b-card no-body class="mb-4">
											<paginated-results>
												<b-card-header
													header-tag="header"
													header-bg-variant="primary"
													role="tab"
													class="p-0 border-b-0"
												>
													<b-button
														block
														@click="collapseMyRequests = !collapseMyRequests"
														variant="primary"
														role="tab"
														class="text-left px-4 py-3 m-0 font-weight-bold"
													>
														<font-awesome-icon
															class="ml-0"
															:icon="collapseMyRequests ? 'chevron-down' : 'chevron-right'"
															fixed-width
														/>
														<span>My Submission</span>
														<b-badge v-if="outgoinglength" pill variant="info" class="ml-3">
															{{ outgoinglength }}
														</b-badge>
													</b-button>
												</b-card-header>
												<b-collapse v-model="collapseMyRequests" role="tabpanel">
																				<!--	<b-card-header v-if="!empty && hasMultiplePages" class="text-right">
														<b-row class="d-flex justify-content-between align-items-center">
															<b-col cols="4" class="text-left">
																<p class="font-weight-bold small text-muted mb-0">
																	Page {{ page }} / {{ pages }}
																</p>
															</b-col>
															<b-col cols="8" class="text-right">
																<simple-pagination
																	v-bind="{ loading, prevPage, hasPrevPage, nextPage, hasNextPage }"
																/>
															</b-col>
														</b-row>
													</b-card-header> -->
													<b-card-header v-if="outgoinglength > outgoingperPage" class="text-right">
														<b-row class="d-flex justify-content-between align-items-center">
															<b-col cols="4" class="text-left">
																<p class="font-weight-bold small text-muted mb-0">
																	Page {{ outgoingPage }} / {{totalPages}}
																</p>
															</b-col>
															<b-col cols="8" class="text-right">
																<b-button-group>
																	<b-button @click="prevPag" title="Previous Page" :disabled="outgoingPage === 1">
																		<font-awesome-icon icon="chevron-left" fixed-width />
																		<span class="d-none d-sm-inline">Prev</span>
																	</b-button>

																	<b-button @click="nextPag" title="Next Page" :disabled="outgoingPage * outgoingperPage >= outgoinglength">
																		<span class="d-none d-sm-inline">Next</span>
																		<font-awesome-icon icon="chevron-right" fixed-width />
																	</b-button>
																</b-button-group>
															</b-col>


														</b-row>
													</b-card-header>

													<loading-indicator v-if="isLoadingOutgoing && isFirstLoad" class="my-5" />
													
											<div class="responsive-table-wrapper">
                                             <div class="responsive-table">
											<b-table
												striped hover
												:items="calculatedOutgoing"
												:fields="outgoingData"
												@sort-changed="onSortChange"
												@row-clicked="onRowClicked"
												v-if="outgoinglength > 0"
												class="custom-table"
											>
												<template #cell(id)="data">
													<div v-if="data.item.request_id" class="d-flex justify-content-between align-items-center font-weight-bold">
														<span>{{ data.item.id }}</span>
														<span :class="data.item.case_request?.deleted !== null ? 'circle-badger' : 'circle-badge'">R</span>
													</div>
													<span v-else>
														{{ data.item.id }}
													</span>
												</template>
												<template #cell(case.patient.full_name)="data">
													<span v-if="data.item.case && data.item.case.patient && data.item.case.patient.full_name " :title="data.item.case.patient.full_name">
														{{ data.item.case.patient.full_name }}
													</span>
													<span v-else>
														&mdash;
													</span>
												</template>
												<template  #cell(case.admit_date)="data">
													<span v-if="data.item.case.admit_date">{{ $filters.formatDate(data.item.case.admit_date) }}</span>
													<span v-else>&mdash;</span>
												</template>

												<template #cell(case.discharge_date)="data">
													<span v-if="data.item.case.discharge_date">{{ $filters.formatDate(data.item.case.discharge_date) }}</span>
													<span v-else>&mdash;</span>
												</template>
												<template #cell(facility_name)="data">
													<span v-if="data.item.facility_name" :title=" data.item.facility_name ">{{ data.item.facility_name }}</span>
													<span v-else>&mdash;</span>
												</template>
												<template #cell(case.facility.bill_type)="data">
													<span v-if="data.item.case && data.item.case.facility && data.item.case.facility.bill_type">
													{{ data.item.case.facility.bill_type }}
													</span>
													<span v-else>&mdash;</span>
												</template>
												<template #cell(case.insurance_provider.name)="data">												
													<span v-if="data.item.case && data.item.case.insurance_provider && data.item.case.insurance_provider.name" :title="data.item.case.insurance_provider.name">
													{{ data.item.case.insurance_provider.name }}
													</span>
													<span v-else>&mdash;</span>								
												</template>
												<template #cell(appeal_level_name)="data">
													<span v-if="data.item.appeal_level_name">{{ data.item.appeal_level_name }}</span>
													<span v-else>&mdash;</span>
												</template>
												<template #cell(sent_date_time)="data">										
													<span v-if="data.item.sent_date_time">
													<span >
														{{ $filters.formatDate(data.item.sent_date_time) }}
													</span>
													</span>
													<span v-else>&mdash;</span>
												</template>
												<template #cell(calculated_sent_date_time)="data">
													<span v-if="data.item.calculated_sent_date_time">{{ $filters.formatDate(data.item.calculated_sent_date_time) }}</span>
													<span v-else>&mdash;</span>
												</template>

											</b-table>
                                </div>
								</div>
								<empty-result v-if="outgoinglength === 0" icon="check-circle">
									No Submission
									<template #content>
										<p class="mb-0">No Submission are assigned to you at this time.</p>
										<p class="mb-0">You're all caught up!</p>
									</template>
								</empty-result>
							</b-collapse>
						</paginated-results>
					</b-card>
				</b-col>
			</b-row>
		</b-container>
	</div>
</template>

<script type="text/javascript">
import { mapGetters } from "vuex";

import { getAppealQueue, getCaseRequestQueue } from "@/clients/services/queue";
import { getIndex as GetCases } from "@/clients/services/cases";

import AppealsLineChart from "@/clients/components/charts/AppealsLine.vue";
import CasesBarChart from "@/clients/components/charts/CasesBar.vue";

import AppealStatusLabel from "@/clients/components/Appeals/StatusLabel.vue";
import PatientSearchInput from "@/clients/components/Patients/SearchInput.vue";

import Calendar from "@/clients/components/Dashboard/Calendar.vue";
import RecentNotes from "@/clients/components/Dashboard/RecentNotes.vue";

import CaseIndex from "@/clients/components/Cases/Index.vue";
import axios from "axios";

import FullCalendar from '@fullcalendar/vue'
import dayGridPlugin from '@fullcalendar/daygrid'
import interactionPlugin from '@fullcalendar/interaction'
import moment from "moment";

export default {
	name: "Dashboard",
	components: {
		AppealsLineChart,
		CasesBarChart,
		AppealStatusLabel,
		PatientSearchInput,
		Calendar,
		FullCalendar,
		RecentNotes,
		CaseIndex,
	},
	// props: {
    //     startDate: {
	// 		type: Object,
	// 		default: () => {
	// 			return moment().startOf('month');
	// 		},
	// 	},
	// 	endDate: {
	// 		type: Object,
	// 		default: () => {
	// 			return moment().endOf('month');
	// 		},
	// 	},
    // },
	data() {
		return {
			item: {
        	case: null  // Assume case might be null
      		},
			startDate: moment().startOf('month'),
            endDate: moment().endOf('month'),
			InProcess_setGradient:true,
			submitted_setGradient:false,
			unassigned_setGradient:false,
			selectedFilter: 'weekly',
			clickedDate: 'Appeals this month',
			previousClickedDate: null,
			timer: null,
			totalOpenCases: null,
			totalMyAppeals: null,
			totalMyRequests: null,

			queuePerPage: 8,
			fields: [
				{ key: 'id', label: 'Appeal ID', sortable: true,thStyle: { width: '140px' } },
				{ key: 'case.patient.full_name', label: 'Patient Name', sortable: true,thStyle: { width: '200px' } },
				{ key: 'case.admit_date', label: 'Begin DOS', sortable: true,thStyle: { width: '120px' } },
				{ key: 'case.discharge_date', label: 'End DOS', sortable: true,thStyle: { width: '120px' } },
				{ key: 'case.facility.name', label: 'Facility Name', sortable: true,thStyle: { width: '220px' } },
				{ key: 'case.facility.bill_type', label: 'LOB', sortable: true,thStyle: { width: '150px' } },
				{ key: 'case.insurance_provider.name', label: 'Insurance Provider', sortable: true,thStyle: { width: '200px' } },
				{ key: 'insurance_provider_appeal_level.label', label: 'Appeal Level', sortable: true,thStyle: { width: '140px' } },
				{ key: 'due_date', label: 'Due Date', sortable: true,thStyle: { width: '110px' } },
				{ key: 'priority', label: 'Priority', sortable: false,thStyle: { width: '110px' } }
			],
			outgoingData: [
				{ key: 'id', label: 'Submit ID', sortable: true,thStyle: { width: '110px' }  },
				{ key: 'case.patient.full_name', label: 'Patient Name', sortable: true,thStyle: { width: '200px' }  },
				{ key: 'case.admit_date', label: 'Begin DOS', sortable: true,thStyle: { width: '120px' }  },
				{ key: 'case.discharge_date', label: 'End DOS', sortable: true,thStyle: { width: '120px' }  },
				{ key: 'facility_name', label: 'Facility Name', sortable: true,thStyle: { width: '220px' }  },
				{ key: 'case.facility.bill_type', label: 'LOB', sortable: true,thStyle: { width: '150px' }  },
				{ key: 'case.insurance_provider.name', label: 'Insurance Provider', sortable: true,thStyle: { width: '200px' }  },
				{ key: 'appeal_level_name', label: ' Appeal Level', sortable: true,thStyle: { width: '140px' }  },
				{ key: 'sent_date_time', label: 'Sent Date', sortable: true,thStyle: { width: '110px' }  },
				{ key: 'calculated_sent_date_time', label: 'Est. Date', sortable: true,thStyle: { width: '110px' }  },
			],
			patient: {
				id: null,
				list_name: null,
			},
			currentPage: 1, 
			currentPag: 1, 
            itemsPerPage:8,
			accName:null,
			myoutgoing: [],
			outgoinglength :'',
			entity : null,
			emptyy: false,
			myappealid:[],
			mainappealid:[],
		    filteredCases: [],
		    insurance:[],
			mylable:[],
			finalAppeal:[],
			myCases:[],
			myPatient:[],
			caseid:[],
			userid:null,
			totalCases:null,
			openCases:null,
			closedCases:null,
			totalAppeal:null,
			totalOpenAppeal:null,
			totalClosedAppeal:null,
			totalfavAppeal:null,
			totalUnfavAppeal:null,
			totalPartFavAppeal:null,
			toalCaseClaims:null,
			totalReimbursement:null,
			totalPaid:null,
			totalCasesClaimData:null,
			currentMonth:null,
			newCaseNum:null,
			recentReiumbersedAmt:null,
			recentPaid:null,
			sortByKey: null,
			myResults: [],
			isLoading:false,
			isLoadingOutgoing: false,
			isFirstLoad: true,
			isFirstLoadAppeal : true,
			appeallength:'',
			sorts: '',
			sortByColumns: '',
			sortDirections: 'asc',
			collapseMyRequests : true,
			totalUnassignedCases:null,
			totalUnassignedAppeals:null,
			calendarOptions: {
				plugins: [ dayGridPlugin, interactionPlugin ],
				initialView: 'dayGridMonth',
				dateClick: this.handleDateClick,
				events: [
				],
				height: 447,
				fixedWeekCount: false,
				contentHeight: 350,
				aspectRatio: 5,
				// eventColor: '#378006',
				// eventBackgroundColor: 'white',
				// eventTextColor: '#000000',
				 // Add event handler for previous and next month buttons
				 headerToolbar: {
					left: 'title',
					center: '',
					// right: 'Cases,Appeals,MyAppeals'
					right: 'prevYear,prev,next,nextYear'
				},
				customButtons: {
					prev: {
						text: 'PrevMonth',
						click: async () => {
							
							let calendarApi = this.$refs.fullCalendar.getApi();
							calendarApi.prev();
							let currentDate = calendarApi.getDate(); // Get the current date of the calendar view
							this.clickedDate = moment(currentDate).format('MMMM, YYYY'); // Format the date as 'Month Name, Year'
							this.startDate = moment(currentDate).startOf('month').toDate();
							this.endDate = moment(currentDate).endOf('month').toDate();
						
							this.showTodayAppealStatus = false;
							await this.getAppealsForCalendar();
						}
					},
					next: {
						text: 'NextMonth',
						click: async () => {
							
							let calendarApi = this.$refs.fullCalendar.getApi();
							calendarApi.next();
							let currentDate = calendarApi.getDate(); // Get the current date of the calendar view
							this.clickedDate = moment(currentDate).format('MMMM, YYYY'); // Format the date as 'Month Name, Year'
							this.startDate = moment(currentDate).startOf('month').toDate();
							this.endDate = moment(currentDate).endOf('month').toDate();
							
							this.showTodayAppealStatus = false;
							await this.getAppealsForCalendar();
						}
					},
					Cases: {
						text: 'Cases',
						click: async () => {
							
						}
					},
					Appeals: {
						text: 'Appeals',
						click: async () => {
							
						}
					},
					MyAppeals: {
						text: 'MyAppeals',
						click: async () => {
							
						}
					}
				}

			},
			valueForOpenAppeals:'',
			valueForTotalAppeals:'',
			valueForInProcessAppeals:'',
			AllAppealsCount:'',
			All_InProcessCount:'',
			All_SubmittedCount:'',
			All_UnassignedCount:'',
			monthlyUnassignedCount:'',
			monthlyInProcessCount:'',
			monthlySubmittedCount:'',
			cal_FilterParam:'',
			showTodayAppealStatus: false,
			showCardInfo: true,
			showTabInfo: false,
			tabText: 'In Process',
			sortField: 'id', 
			sortDirection: 'desc',
			outgoingPage:1,
            outgoingperPage:8,
			sortedRequests: [],
			id_arr: [],
			case_idArr: [],
			sortBy: 'priority',
            sortDesc: true,
		};
	},
	computed: {
	formattedAdmitDate() {
    if (this.data.item.case && this.data.item.case.admit_date) {
      return this.$filters.formatDate(this.data.item.case.admit_date);
    }
    return 'No admit date'; 
  },
  	formattedDischargeDate() {
  	return this.data.item.case?.discharge_date ? this.$filters.formatDate(this.data.item.case.discharge_date) : 'No discharge date';
	},
		totalPages() {
			return Math.ceil(this.outgoinglength / this.itemsPerPage);
		},
		totalappealpages() {
			return Math.ceil(this.appeallength / this.itemsPerPage);
		},
		sortedAndPaginatedResults() {
			// Get the starting index of the current page
			const startIndex = (this.currentPag - 1) * this.itemsPerPage;

			// Slice the array to return only the items for the current page
			return this.myResults.slice(startIndex, startIndex + this.itemsPerPage);
		},

        calculatedOutgoing() {
			return this.myoutgoing.map(item => {
				let calculatedDate = null;
				if (item.sent_date_time) {
					const maxDays = item.appeal?.insurance_provider_appeal_level?.max_days || 0;
					const sentDate = new Date(item.sent_date_time);
					calculatedDate = new Date(sentDate.getTime() + maxDays * 24 * 60 * 60 * 1000);
				}
				return {
					...item,
					calculated_sent_date_time: calculatedDate ? calculatedDate.toISOString() : null
				};
			});
		},

		collapseCalendar: {
			get() {
				return this.showCalendar;
			},
			set(val) {
				this.$store.commit("dashboard/showCalendar", val);
			},
		},
		collapseNotes: {
			get() {
				return this.showNotes;
			},
			set(val) {
				this.$store.commit("dashboard/showNotes", val);
			},
		},
		collapseMyAppeals: {
			get() {
				return this.showMyAppeals;
			},
			set(val) {
				this.$store.commit("dashboard/showMyAppeals", val);
			},
		},
		...mapGetters({
			// Global
			clientName: "clientName",

			// Dashboard
			loading: "dashboard/loading",
			assignedAppeals: "dashboard/assignedAppeals",
			assignedCases: "dashboard/assignedCases",
			assignedDocuments: "dashboard/assignedDocuments",
			returnedAppeals: "dashboard/returnedAppeals",
			completedAppeals: "dashboard/completedAppeals",
			// showCalendar: "dashboard/showCalendar",
			showNotes: "dashboard/showNotes",
			showMyAppeals: "dashboard/showMyAppeals",
			showMyRequests: "dashboard/showMyRequests",

			// Appeals
			loadingAppealsOpenByAssignedUser: "appeals/loadingOpenByAssignedUser",
			appealsOpenByAssignedUser: "appeals/openByAssignedUser",

			// Statistics
			unassignedAppeals: "statistics/unassignedAppeals",
			emptyCases: "statistics/emptyCases",
			favorableCasesPercent: "statistics/favorableCasesPercent",
			openClaimsTotal: "statistics/openClaimsTotal",
			reimbursedTotal: "statistics/reimbursedTotal",

			// State
			openCaseCount: "openCaseCount",
			openAppealCount: "openAppealCount",
			openCaseRequestCount: "openCaseRequestCount",
			incomingDocumentCount: "incomingDocuments/count",

			// User
			currentUserId: "userId",
			user: "user",
			usersOnline: "users/online",
			loadingUsers: "users/loadingActive",
			users: "users/active",
		}),
		limitedAppealsOpenByAssignedUser() {
        return this.appealsOpenByAssignedUser.slice(0, 4);
    },
	formattedClickedDate() {
			// Format the clicked date as desired
			// You can use libraries like moment.js for advanced formatting
			// console.log('inside formatted Clicked date');
			// console.log('clicked date is:');
			// console.log(this.clickedDate);
			// if (this.clickedDate) {
			// 	const dateObj = new Date(this.clickedDate);
			// 	return dateObj.toLocaleDateString('en-US', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' });
			// } else {
			// 	const today = new Date(); // Get today's date
   			//  return today.toLocaleDateString('en-US', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' });
			// }
			if (this.clickedDate) {
				// const dateObj = new Date(this.clickedDate);
				const dateObj = moment(this.clickedDate).local().toDate();
				return dateObj.toLocaleDateString('en-US', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' });
			} else {
				// const today = new Date(); // Get today's date
				const today = moment().local().toDate();
        		return today.toLocaleDateString('en-US', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' });
			}
		}
	},
	created() {
		// Reload every minute
		this.timer = setInterval(this.refresh, 60000);
	},
	mounted() {
		this.calendarApi = this.$refs.fullCalendar.getApi();
		this.refresh();
		this.outgoingDetails();
		this.getAppealsForCalendar();
		this.fetchDetails();
		this.fetchCaseNumberData();
		this.appealDetails();
		
	},
	methods: {
		handleDateClick: function(arg) {
			this.showTodayAppealStatus = true;
			this.showCardInfo = false;
			this.showTabInfo = true;
			// alert('date click! ' + arg.dateStr)
			if (this.previousClickedDate !== null) {
				this.previousClickedDate.style.backgroundColor = ''; // Reset to default color
			}

			// Get the clicked date
			arg.dayEl.style.backgroundColor = '#9AEF9A';
			arg.dayEl.style.textColor = 'black';
			// Update previousClickedDate
			this.previousClickedDate = arg.dayEl;
			
			const clickedDate = arg.dateStr;
			this.clickedDate = clickedDate;
			// this.clickedDate = moment(clickedDate).format('MMMM, YYYY');;
			
			
			// Find events corresponding to the clicked date
			const clickedEvents = this.calendarOptions.events.filter(event => event.date === clickedDate);
			
			// Accumulate the titles of clicked events
			const clickedEventTitles = clickedEvents.map(event => event.title);
			const clickedEventTitles2 = clickedEvents.map(event => event.open);
			const clickedEventTitles3 = clickedEvents.map(event => event.inProcess);
			
			
			// Extract the number from the title (e.g., 'open:22' => 22)
			const numberFromTitle = clickedEventTitles.length > 0 ? parseInt(clickedEventTitles[0].match(/\d+/)) : 0;
			const numberFromTitle2 = clickedEventTitles2.length > 0 ? parseInt(clickedEventTitles2[0]) : 0;
			const numberFromTitle3 = clickedEventTitles3.length > 0 ? parseInt(clickedEventTitles3[0]) : 0;
			
			// // Update the value inside the <h3> tag with the extracted number
			this.valueForTotalAppeals = numberFromTitle;
			this.valueForOpenAppeals = numberFromTitle2;
			this.valueForInProcessAppeals =numberFromTitle3 || numberFromTitle2;
			
			// // Display the titles using alert
			// if (clickedEventTitles.length > 0) {
			// 	alert(`Events on ${clickedDate}: ${clickedEventTitles.join(', ')}`);
			// } else {
			// 	alert(`No events on ${clickedDate}`);
			// }
		},
	isDueToday(dueDate) {
      const today = new Date();
      const due = new Date(dueDate);
      const formattedToday = this.$filters.formatDate(today);
      const formattedDue = this.$filters.formatDate(due);
      return formattedDue === formattedToday;
    },
    isDueInFuture(dueDate) {
      const today = new Date();
      const due = new Date(dueDate);
      return due.getTime() > today.getTime();
    },
    daysUntilDue(dueDate) {
      const today = new Date();
      const due = new Date(dueDate);
      const timeDiff = due.getTime() - today.getTime();
      const daysDiff = Math.ceil(timeDiff / (1000 * 3600 * 24));
      return daysDiff;
    },
    daysAgo(dueDate) {
      const today = new Date();
      const due = new Date(dueDate);
      const timeDiff = today.getTime() - due.getTime();
      const daysDiff = Math.floor(timeDiff / (1000 * 3600 * 24));
      return daysDiff;
    },
		async refresh() {
			await this.$store.dispatch("dashboard/refresh");
			await this.$store.dispatch("statistics/refresh");
			await this.$store.dispatch("appeals/openByAssignedUser");
			// get appeals data to display in calendar as events
			// let response = await this.$store.dispatch("charts/getAppealsForCalendar", {
			// 	start: this.startDate.format(this.dateFormat),
			// 	end: this.endDate.format(this.dateFormat),
			// 	params: this.params,
			// });
		},
		async getAppealsForCalendar(){
		
			let response = await this.$store.dispatch("charts/getAppealsForCalendar", {
				start: moment(this.startDate).format(this.dateFormat),
                end:  moment(this.endDate).format(this.dateFormat),
				params: this.params,
				cal_FilterParam: this.cal_FilterParam
			});

			
			
			// set all appeals count
			this.showTodayAppealStatus = false;
			this.showCardInfo = true;
			this.AllAppealsCount = response.AllAppealsCount;
			//  set All InProcess appeals which are either open or inprocess
			this.All_InProcessCount = response.All_InProcessCount;
			this.valueForInProcessAppeals = response.All_InProcessCount;
			this.monthlyUnassignedCount = response.monthlyUnassignedCount;
			this.monthlyInProcessCount = response.monthlyInProcessCount;
			this.monthlySubmittedCount = response.monthlySubmittedCount;
			// set All submitted appeals
			this.All_SubmittedCount = response.All_SubmittedCount;
			this.All_UnassignedCount = response.All_UnassignedCount;
			this.calendarOptions.events = []; // Empty the events array
			Object.keys(response.created).forEach(date => {
				let eventData = {};
				const count = response.created[date] || 0; 
				const inProcessCount = response.created[date] || 0; 
			
				// const total = inProcessCount;
				eventData.title = `(${inProcessCount})`; //title will be sum of all open and inprocess at this particular event date
				// if (date in response.inProcess) {
				// 	eventData.title += response.inProcess[date];
				// }
				// Convert date format from 'MM-DD-YYYY' to 'YYYY-MM-DD'
				const [month, day, year] = date.split('-');
				eventData.date = `${year}-${month}-${day}`;
			
				eventData.open =  response.created[date] || 0;  // total open count at this date
				eventData.inProcess = response.inProcess[date] || 0; 
				// eventData.display = 'background';
				eventData.display = 'list-item';
				eventData.backgroundColor = '#A1F0A1';
				// eventData.backgroundColor = 'white';
				eventData.textColor = 'black';
				eventData.borderColor = '#A1F0A1';
				this.calendarOptions.events.push(eventData);
			});
		},
		cal_monthlyUnassigned(){
			this.InProcess_setGradient = false;
			this.submitted_setGradient = false;
			this.unassigned_setGradient = true;
			this.showCardInfo = false;
			this.showTabInfo = true;
			this.tabText = 'Unassigned';
			if (this.previousClickedDate !== null) {
				this.previousClickedDate.style.backgroundColor = ''; // Reset to default color
			}
			this.cal_FilterParam = 'Unassigned'
			this.getAppealsForCalendar();
		},
		cal_monthlySubmitted(){
			this.InProcess_setGradient = false;
			this.submitted_setGradient = true;
			this.unassigned_setGradient = false;
			this.showCardInfo = false;
			this.showTabInfo = true;
			this.tabText = 'Submitted';
			if (this.previousClickedDate !== null) {
				this.previousClickedDate.style.backgroundColor = ''; // Reset to default color
			}
			this.cal_FilterParam = 'submitted'
			this.getAppealsForCalendar();
		},
		cal_monthlyInProcess(){
			this.InProcess_setGradient = true;
			this.submitted_setGradient = false;
			this.unassigned_setGradient = false;
			this.showCardInfo = false;
			this.showTabInfo = true;
			this.tabText = 'In Process';
			if (this.previousClickedDate !== null) {
				this.previousClickedDate.style.backgroundColor = ''; // Reset to default color
			}
			this.cal_FilterParam = 'inProcess'
			this.getAppealsForCalendar();
		},
		async getOpenCases(params) {
			return await GetCases({
				status: "Open",
				...params,
			});
		},
	//	async getAppealQueue(params) {
	//		return await getAppealQueue(params);
	//	},
		async getRequestQueue(params) {
			return await getCaseRequestQueue(params);
		},
		viewCase(caseEntity) {
			this.$router.push({
				name: "cases.view",
				params: {
					id: caseEntity.id,
				},
			});
		},
		onRowClick(item) {
			if(item.request_type === 'DOCUMENTATION' || item.request_type === 'HEARING' || item.request_type === 'MedicalRecord') {
		this.$router.push({
			name: 'appeals.view',
			params: { id: item.case_id, appeal_id: item.request_type === 'DOCUMENTATION' || item.request_type === 'HEARING' || item.request_type === 'MedicalRecord' ? item.appeal_level : item.id, case_request_id:item.id,redirected: 'request' }, 
		});
		} else {
			this.$router.push({
			name: 'appeals.view',
			params: { id: item.case_id, appeal_id: item.request_type === 'DOCUMENTATION' || item.request_type === 'HEARING' || item.request_type === 'MedicalRecord' ? item.appeal_level : item.id, case_request_id:item.id }, 
		});	
		} 
		},
		async fetchDetails(){
			const url = "/client/fetchdetails";
				
				const response = await axios.get(url, {
				headers: {
					"Accept": "application/json",
					// You can add other headers here if needed
				},
				});
				
				this.accName = response.data[0].name
				

		},
		async fetchCaseNumberData(){
			const url = "/client/api/countData";
			const response = await axios.get(url, {
				headers: {
					"Accept": "application/json",
					// You can add other headers here if needed
				},
				});
			
			this.totalCases = response.data.total_case;
			this.openCases = response.data.open_case;
			this.closedCases = response.data.closed_case;
			this.totalClosedAppeal = response.data.closed_appeal;
			this.totalOpenAppeal = response.data.open_appeal;
			this.totalAppeal = response.data.total_appeal;
			this.totalfavAppeal = response.data.favorable;
			this.totalunFavAppeal= response.data.unfavorable;
			this.totalPartFavAppeal = response.data.Partially_fav;
			// this.toalCaseClaims = (response.data.case_claims / 1000).toFixed(1);
			this.totalReimbursement = (response.data.reimbursement / 1000).toFixed(1);
			this.totalPaid = (response.data.paid / 1000).toFixed(1);
			this.totalCasesClaimData = (response.data.totalCasesClaimAmt / 1000).toFixed(1);
			this.newCaseNum = response.data.newCase;
			var currentDate = new Date();
			this.recentReiumbersedAmt = (response.data.totalRecentReiumbAmt / 1000).toFixed(1);
			this.recentPaid = (response.data.recentPaid / 1000).toFixed(1);
			this.totalSubmittedAppeals = response.data.submittedAppeals;
			this.totalUnassignedCases = response.data.totalUnassignedCases;
			this.totalUnassignedAppeals = response.data.totalUnassignedAppeals;
			if (response.data.case_claims >= 1000000) {
				this.toalCaseClaims = (response.data.case_claims / 1000000).toFixed(1) + 'M';
			} else if (response.data.case_claims >= 1000) {
				this.toalCaseClaims = (response.data.case_claims / 1000).toFixed(1) + 'K';
			} else {
				this.toalCaseClaims = response.data.case_claims;
			}


			// Get the current month (0-indexed, so January is 0)
			var currentMonth = currentDate.getMonth() + 1; // Adding 1 to match the actual month number
			// Optionally, you can get the month name
			var monthNames = ["January", "February", "March", "April", "May", "June",
			"July", "August", "September", "October", "November", "December"
			];
			var currentMonthName = monthNames[currentDate.getMonth()];
			this.currentMonth = currentMonthName;
			
		},
		async appealDetails() {
			   if (this.isFirstLoadAppeal) {
             if (this.isFirstLoadAppeal) {
            this.isLoading = true;
        }
        }
			try {
				this.isLoading = true; // Set loading indicator to true before fetching data
				const url = "/client/appealList"; // Corrected the URL string
				const response = await axios.get(url, {
					 params: {
						page: this.currentPag,
						perPage: 8,
					},
					headers: {
						"Accept": "application/json",
						// You can add other headers here if needed
					},
				});
				
				// this.myResults = response.data.appeals;
				// this.myResults = response.data.appeals.concat(response.data.caseRequests);
				this.myResults = response.data.appeals;
				this.appeallength = this.myResults.length;
				this.isFirstLoadAppeal = false;
			} catch (error) {
				console.error("Error fetching data:", error.message);
			} finally {
				this.isLoading = false; // Set loading indicator to false after data is fetched
			}
    	},

	async outgoingDetails() {
             if (this.isFirstLoad) {
             if (this.isFirstLoad) {
            this.isLoadingOutgoing = true;
        }
        }
            try {
				const response = await axios.get("/client/newOutgoing", {
					params: {
						sort: this.sortField,  
						direction: this.sortDirection,
						limit: this.outgoingperPage,
						page:this.outgoingPage,
					},
				headers: { "Accept": "application/json" },
				});
				
				this.myoutgoing = response.data.data;
				
				this.outgoinglength = response.data.total;
				this.isFirstLoad = false;
				
            } catch (error) {
                console.error("Error fetching data:", error.message);
            } finally {
                this.isLoadingOutgoing = false;
            }
        },
		onSortChange({ sortBy, sortDesc }) {
		if (sortBy === 'calculated_sent_date_time') {
				this.sortField = 'sent_date_time';  
		} else {
			
				this.sortField = sortBy === 'id' ? 'OutgoingDocuments.id' : sortBy;
		}
		this.sortDirection = sortDesc ? 'desc' : 'asc';
		this.outgoingDetails();
		},
		
		onRowClicked(item) {
			
			if (item.request_id !== null) {
			this.$router.push({
				name: "appeals.view",
				params: {
					id: item.case_id,
					appeal_id: item.appeal_id,
					case_request_id:item.request_id,
					redirected: 'request'
				},
			});
			} else {
			this.$router.push({
				name: 'appeals.view',
				params: { id: item.case_id, appeal_id: item.appeal_id },
			});
			}
		},
        getFieldVal(item, column) {
            switch (column) {
				case 'id':
                    return item && item.id ? item.id : '&mdash;';
                case 'patient_name':
                    return item.case && item.case.patient ? `${item.case.patient.first_name} ${item.case.patient.last_name}` : '&mdash;';
                case 'facility_name':
                    return item.case && item.case.facility ? item.case.facility.name : '&mdash;';
                case 'level':
                    return item.appeal && item.appeal.insurance_provider_appeal_level ? item.appeal.insurance_provider_appeal_level.label : '&mdash;';
                case 'sent_date':
                    return item.sent_date_time ? this.$filters.formatDate(item.sent_date_time) : '&mdash;';
                case 'est_date':
                    const maxDays = item.appeal && item.appeal.insurance_provider_appeal_level ? item.appeal.insurance_provider_appeal_level.max_days * 24 * 60 * 60 * 1000 : 0;
                    const sentDateTime = item.sent_date_time ? new Date(item.sent_date_time).getTime() : 0;
                    return this.$filters.formatDate(new Date(sentDateTime + maxDays));
                default:
                    return '&mdash;';
            }
        },
        nextPag() {
            if (this.outgoingPage * this.outgoingperPage < this.outgoinglength) {
				this.outgoingPage++;
				this.outgoingDetails();
            }
        },
        prevPag() {
            if (this.outgoingPage > 1) {
				this.outgoingPage--;
				this.outgoingDetails();
            }
        },
				async getAppealQueue(params) {
				//console.log("Fetching appeal queue...");
				try {
					const response = await getAppealQueue(params); // Assuming getAppealQueue is defined elsewhere
				//  console.log("Response received:", response);

					const results = response?.data || [];
					// Update component state with fetched data
					//this.myResults = results;

					// Log the new array
				// console.log("My Results:", this.myResults);

					// Return the response
					return response;
				} catch (error) {
					console.error("Error fetching appeal queue:", error);
					throw error; // Rethrow the error
				}
				},
				sortBy(column) {
					if (this.sortByColumns === column) {
						this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
					} else {
						this.sortByColumns = column;
						this.sortDirection = 'asc';
					}
				},
				nextPagee() {
					if (this.currentPag < this.totalappealpages) {
						this.currentPag++;
					}
				},
				prevPagee() {
					if (this.currentPag > 1) {
						this.currentPag--;
					}
		        },
				sortChanged(ctx) {
				this.sortBy = ctx.sortBy;
				this.sortDesc = ctx.sortDesc;
				this.appealDetails();
				},
				getFieldValue(item, column) {
					switch (column) {
						case 'id':
						return item.id.toString();
						case 'patient_name':
						return item.case && item.case.patient ? (item.case.patient.full_name || '') : '';
						case 'begin_dos':
						return item.case ? (item.case.admit_date || '') : '';
						case 'end_dos':
						return item.case ? (item.case.discharge_date || '') : '';
						case 'facility_name':
						return item.case && item.case.facility ? (item.case.facility.name || '') : '';
						case 'bill_name':
						return item.case && item.case.facility ? (item.case.facility.bill_type || '') : '';
						case 'insurance_provider_name':
						return item.case && item.case.insurance_provider ? (item.case.insurance_provider.name || '') : '';
						case 'level_name':
						return item.insurance_provider_appeal_level ? (item.insurance_provider_appeal_level.label || '') : '';
						case 'priority':
						return item.priority ? '1' : '0';
						case 'due_date':
						return item.due_date || '';
						default:
						return '';
					}
				},	
				async getSortedRequests(){
					// fetch request related data based on id_arr
					

					const response = await this.$store.dispatch("caseRequests/getRequestbyIDs", {
						id: this.id_arr,
						case_id: this.case_idArr
					});
					

					this.sortedRequests = response.results;
				},		

	},
	updated(){
		// this.getSortedRequests();
	},
	destroyed() {
		clearInterval(this.timer);
	},
	watch: {
    currentPage: 'appealDetails',
    },
};
</script>
<style>
.smaller-text-muted {
    font-size: smaller; /* You can adjust this value as needed */
}

.section-box {
    border: 1px solid #ced4da;
    border-radius: 0.25rem;
    padding: 5px;
    /* margin-bottom: 5px; */
    background-color: white; /* optional: set background color */
	text-align: center;
    
}

.smaller-card {
	padding-bottom: 0 !important;
	border-bottom: 3px solid transparent;
	transition: border-color 0.3s;
}
.smaller-card:hover {
        border-bottom-color: blue; /* Change color on hover */
}
.newCaseNum{
	border-bottom-color: #2196F3;
}
.toalCaseClaims{
	border-bottom-color: #FF9800;
}
.openAppealCount{
	border-bottom-color: #009688;
}
.totalSubmittedAppeals{
	border-bottom-color: #8BC34A;
}
 .notification-badge {
    position: relative;
    top: -10px;
    right: 20px;
    transform: translate(50%, -50%);
    background-color: red;
    color: white;
    font-size: 0.5rem; /* Adjust font size as needed */
    padding: 0.15rem 0.3rem; /* Adjust padding as needed */
    border-radius: 50%;
} 

/* .notification-badge {
    position: absolute;
    top: -10px;
    right: 20px;
    background-color: red;
    color: white;
    font-size: 0.5rem;
    padding: 0.15rem 0.3rem;
    border-radius: 50%;
} */

.ringing {
    animation: ring 0.5s infinite alternate;
}

@keyframes ring {
    0% {
        transform: scale(1);
    }
    100% {
        transform: scale(1.2);
    }
}

.smaller-text-muted {
    font-size: smaller; /* You can adjust this value as needed */
}

.section-box {
    border: 1px solid #ced4da;
    border-radius: 0.25rem;
    padding: 5px;
    /* margin-bottom: 5px; */
    background-color: white; /* optional: set background color */
	text-align: center;
    
}
.th:hover {
  font-weight: bold;
}
.gradient-background {
  background: linear-gradient(to bottom, #daffd3, #a6e8a4);
  /* background-color: #FFFFFF; */
}

:root {
  --fc-today-bg-color: #ebebeb; /* Set your desired color */
  --fc-border-color: rgb(207, 207, 207);
  --fc-direction-ltr:rgb(220, 220, 220);
}
.fc.fc-media-screen.fc-direction-ltr.fc-theme-standard {
  /* Your CSS styles here */
  background-color: #f9f9f9;
}

.circle-badge {
  display: inline-block;
  width: 24px;
  height: 16px;
  margin-left: 4px;
  line-height: 16px;
  border-radius: 50%;
  background-color: #007bff;
  color: white;
  text-align: center;
  font-size: 12px;
}
.circle-badger {
  display: inline-block;
  width: 24px;
  height: 16px;
  margin-left: 4px;
  line-height: 16px;
  border-radius: 50%;
  background-color: #ff0000; 
  color: white;
  text-align: center;
  font-size: 12px;
}
/* Ensure the parent wrapper allows horizontal scrolling */
.table-responsive-wrapper {
  max-width: 100%; /* Ensures the div takes up the full available width */
  overflow-x: auto; /* Enables horizontal scrolling if content overflows */
}

.responsive-table {
  width: auto; 
  overflow-x: auto;/* Allow the table to grow based on its content */
}

.custom-table {
  width: 100%; 
  table-layout: fixed;
}

.custom-table th, .custom-table td {
  white-space: nowrap; /* Prevents text wrapping */
  overflow: hidden;
  text-overflow: ellipsis; 
}
.circle-badge-green {
  display: inline-block;
  width: 24px;
  height: 16px;
  margin-left: 4px;
  line-height: 16px;
  border-radius: 50%;
  background-color: #9DC183!important;
  color: white;
  text-align: center;
  font-size: 12px;
}






</style>
